<template>
  <div class="footer_com">
    <div style=" width: 100%;padding: 5% 0px;">
      <div style="width: 100%;float: left;position: relative; height: 20vh">
        <img src="/qd_QR.jpg" alt="待加载..." class="footer_com_img" style="width: 30%;">
        <span style="display: block;
                      color: #fff;
                      line-height: 25px;
                      height: 25px;
                      width: 100%;
                      overflow: hidden;
                      padding-top: 35%;
                      font-size: 14px;">
          微信公众平台</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
}
</script>

<style scoped>
.footer_com{
  background: #2c2f34;
  width: 100%;
  height: 200px;
  margin-top: 2%;
  max-width: 1200px;
  padding: 3% 0px;
  float: right;
  position: relative;
}

.footer_com_img{
  padding: 10px;
  border: 1px solid #606060;
  box-sizing: content-box;
  position: absolute;
  top: 0;
  right: 0;
  /*bottom: 0;*/
  left: 0;
  max-width: 100%;
  max-height: 100%;
  display: block;
  vertical-align: middle;
  margin: auto;
}


</style>